export const statusReducer = (state, action) => {
  switch (action.type) {
    case "loadStatus":
      console.log("loading status");
      return loadStatus(state, action.statuses);
    default:
      return state;
  }
};

const loadStatus = (state, statuses) => {
  let newState = [...statuses];

  return newState;

  //console.log(curriculum.data.curriculums);
};
